import React from 'react';
import cx from 'classnames';
import { Image } from 'cw-ui-core';
import css from 'src/styles/App.scss';

const IconButton = props => {
    return (
        <div
            title={props.alt}
            className={props.className ? cx(css.imageButtonWrap, props.className) : css.imageButtonWrap}>
            <Image
                className={props.disabled ? css.imageButtonDisabled : css.imageButton}
                src={props.icon}
                automationName={props.automationName}
                onClick={props.disabled ? undefined : props.onClick}
                alt={props.alt}
                style={props.style}
            />
        </div>
    );
};

export default IconButton;
